import CourseCard from "./CourseCard";
import React, { useState } from "react";
import FacultyPortalStyles from "../../../../styles.js";
import styles from "./CourseCardDisplay.styles";
import { connect } from "react-redux";
import NoCurrentCourses from "./NoCurrentCourses.jsx";
import { useTheme, ThemeProvider } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContentWrapper from "../../../../components/SnackbarContentWrapper";
import facultyPortalTheme from "../../../../facultyPortalTheme.js";


const ExtInProgress = (props) => {
  const classes = styles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));
  const facultyClasses = FacultyPortalStyles();

  const [openSuccess, setOpenSuccess] = useState(false);
  const [ccOpenSuccess, setCcOpenSuccess] = useState(false);
  
  let courseCardKeyCount = 0;


  // Below Code deals with Snackbar
  // -------------------------------------------------------------------------------------------------------------
  const renderSnackbar = (snackbarType, message) => (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={
          openSuccess
            ? true
            : ccOpenSuccess
        }
        autoHideDuration={null}
        onClose={handleClose}
      >
        <SnackbarContentWrapper
          onClose={handleClose}
          handleRetryClick={handleRetryApiCall}
          variant={snackbarType}
          message={message}
        />
      </Snackbar>
    </>
  );

  const handleRetryApiCall = () => {
    console.log("Retrying API call for extended courses in the case of error and user clicks retry button");

    if (props.demographics.issuerId) {
        props.getExtendedCoursesForIrn(props.demographics.issuerId);
      }
    }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccess(false);
  };

  return (
    <ThemeProvider theme={facultyPortalTheme}>
      {ccOpenSuccess &&
        (props.errorMessages.length === 1
          ? renderSnackbar(
              "error",
              props.errorMessages[0].displayMessage.message
            )
          : "")}
      {props.extendedCourses.length >= 1 && (
        props.extendedCourses
          .filter((course) => course.extendedStudentIrnList.length > 0)
          .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
          .map((extendedCourse) => {
          
            return (
              <div
                className={extendedCourse.courseId === null ? classes.hide : ""}
                key={courseCardKeyCount++}
              >
                <CourseCard
                  matches={matches}
                  type="extendedCourses"
                  currentCourse={extendedCourse}
                />
              </div>
            );
          })
        )}
    </ThemeProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    demographics: state.demographics,
    errorMessages: state.errorMessages,
    extendedCourses: state.extendedCourses,
  };
};

export default connect(mapStateToProps)(ExtInProgress);